export type SeedOrderInventoryMtValues = {
  origin_current_mt?: string
  origin_requested_mt?: string
  origin_after_sale_mt?: string
  destination_current_mt?: string
  destination_requested_mt?: string
  destination_after_sale_mt?: string
}

function parseSignedNumber(raw?: string | null): number | null {
  if (raw == null) {
    return null
  }
  const trimmed = raw.trim()
  if (!trimmed) {
    return null
  }
  const normalized = trimmed.replace(/,/g, '')
  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

function formatNumber(value: number): string {
  return value.toFixed(2)
}

function formatRequested(absQuantity: number, isOrigin: boolean): string {
  const sign = isOrigin ? '-' : '+'
  return `${sign}${formatNumber(absQuantity)}`
}

export function computeSeedOrderInventoryMtValues(input: {
  originCurrentMt?: string | null
  destinationCurrentMt?: string | null
  quantityMt?: string | null
}): SeedOrderInventoryMtValues {
  const originCurrent = input.originCurrentMt ?? undefined
  const destinationCurrent = input.destinationCurrentMt ?? undefined
  const quantityParsed = parseSignedNumber(input.quantityMt)

  const result: SeedOrderInventoryMtValues = {
    origin_current_mt: undefined,
    destination_current_mt: undefined,
  }

  const originCurrentNumeric = parseSignedNumber(originCurrent)
  const destinationCurrentNumeric = parseSignedNumber(destinationCurrent)

  if (originCurrentNumeric != null) {
    result.origin_current_mt = formatNumber(originCurrentNumeric)
  }

  if (destinationCurrentNumeric != null) {
    result.destination_current_mt = formatNumber(destinationCurrentNumeric)
  }

  if (quantityParsed == null) {
    return result
  }

  const absQuantity = Math.abs(quantityParsed)
  const originRequestedNumeric = -absQuantity
  const destinationRequestedNumeric = absQuantity

  result.origin_requested_mt = formatRequested(absQuantity, true)
  result.destination_requested_mt = formatRequested(absQuantity, false)

  if (originCurrentNumeric != null) {
    result.origin_after_sale_mt = formatNumber(originCurrentNumeric + originRequestedNumeric)
  }

  if (destinationCurrentNumeric != null) {
    result.destination_after_sale_mt = formatNumber(destinationCurrentNumeric + destinationRequestedNumeric)
  }

  return result
}

export function getAfterSaleColor(value?: string): string | undefined {
  const parsed = parseSignedNumber(value)
  if (parsed == null) {
    return undefined
  }
  return parsed < 0 ? '#CF1322' : '#2F54EB'
}

export function isNegativeMtValue(value?: string): boolean {
  const parsed = parseSignedNumber(value)
  return parsed != null && parsed < 0
}
